/*
 *
 *
 * (c) 2018/8/1 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import eventService from './../index';

class AccountEvent {
  constructor() {
    this.apiPrefix = 'event';

    this.apis = {
      login: `${this.apiPrefix}.account.login`,
      logout: `${this.apiPrefix}.account.logout`
    };
  }

  /**
   * 增加login事件监听
   * @param callback 回调函数
   */
  addLoginListener(callback) {
    eventService.addEventListener(this.apis.login, callback);
  }

  /**
   * 移除login事件监听
   */
  removeLoginListener() {
    eventService.removeEventListener(this.apis.login);
  }

  /**
   * 增加logout事件监听
   * @param callback 回调函数
   */
  addLogoutListener(callback) {
    eventService.addEventListener(this.apis.logout, callback);
  }

  /**
   * 移除logout事件监听
   */
  removeLogoutListener() {
    eventService.removeEventListener(this.apis.logout);
  }
}

export default new AccountEvent();
